import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISendNotificationPayload {
    data: any
}

export interface ISendNotificationState {
    status: string
    data: any
    errors: any
}

const initialState: ISendNotificationState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const sendNotificationSlice = createSlice({
    name: '/notifications/send',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<ISendNotificationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const sendNotificationActions = sendNotificationSlice.actions
export default sendNotificationSlice.reducer
